/* ==========================================================================
   Raseco Theme - Global JavaScript
   ========================================================================== */

(() => {
  'use strict';

  /* ------------------------------------------------------------------------
     1. Helpers
     ------------------------------------------------------------------------ */

  /**
   * Select one element.
   *
   * @param {string} selector
   * @param {Document|Element} context
   * @returns {Element|null}
   */
  const select = (selector, context = document) => {
    return context.querySelector(selector);
  };

  /**
   * Select multiple elements.
   *
   * @param {string} selector
   * @param {Document|Element} context
   * @returns {NodeListOf<Element>}
   */
  const selectAll = (selector, context = document) => {
    return context.querySelectorAll(selector);
  };


  /* ------------------------------------------------------------------------
     2. DOM Ready
     ------------------------------------------------------------------------ */

  const initTheme = () => {
    initDisclosureButtons();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTheme);
  } else {
    initTheme();
  }


  /* ------------------------------------------------------------------------
     3. Disclosure / Toggle buttons
     ------------------------------------------------------------------------ */

  /**
   * Generic toggle functionality.
   *
   * Example:
   *
   * <button
   *   data-toggle="mobile-menu"
   *   aria-expanded="false"
   * >
   *   Menu
   * </button>
   *
   * <div
   *   id="mobile-menu"
   *   data-toggle-target
   *   hidden
   * >
   *   ...
   * </div>
   */

  function initDisclosureButtons() {
    const buttons = selectAll('[data-toggle]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const targetId = button.dataset.toggle;
        const target = document.getElementById(targetId);

        if (!target) return;

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', String(!isOpen));
        target.hidden = isOpen;
      });
    });
  }


  /* ------------------------------------------------------------------------
     4. Shopify Theme Editor
     ------------------------------------------------------------------------ */

  /**
   * Shopify can dynamically reload sections inside the Theme Editor.
   * We can hook section-specific JavaScript into this later.
   */

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;

    if (!section) return;

    // Section-specific initialisation can be added here later.
  });


  /* ------------------------------------------------------------------------
     5. Global Raseco object
     ------------------------------------------------------------------------ */

  window.Raseco = window.Raseco || {};

  window.Raseco.select = select;
  window.Raseco.selectAll = selectAll;

})();